import { mediaCards } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            精彩片花
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门电视剧精彩片花
          </h2>
          <p className="text-sm text-foreground-500 mt-2">高清预告与高能片段，抢先感受剧集魅力</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaCards.map((item) => (
            <article key={item.title} className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-900/80 rounded text-xs text-background-50 font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl" />
                  </div>
                </div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-semibold">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{item.views} 次播放</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}